import { UtenteDTO } from "./utenteDTO";

export class SettoreDTO {
  codice: string;
  nome: string;
  responsabile: any;
  incaricato: UtenteDTO;
  cmu: string;
}
